import React from "react";
import XoiComHeading from "../generics/XoiComHeading";
import { IMAGES } from "../../utils/utils";
import Counter from "../generics/Counter";
import { useSelector } from "react-redux";

function GreenSession({ heading }) {
  const numberCards = useSelector((state) => state.reducer.aboutNumber);
  const language = useSelector((state) => state.reducer.language);

  return (
    <div className="about-green-session">
      <img
        className="background-image"
        src={IMAGES.GREEN_BG}
        alt="about-green"
      />
      <div className="about-green-heading-container">
        <div className="about-green-heading-container-inner">
          <div
            className="about-green-heading"
            style={{ maxWidth: language === "en" && 350 }}
          >
            <XoiComHeading heading={heading} textColor="white" />
          </div>
        </div>
        {numberCards && (
          <div className="about-green-number-card-container">
            {numberCards.map((card, index) => (
              <div
                key={`card-number-${index}`}
                className="about-green-number-card"
              >
                <Counter end={card.number} duration={10} />
                <div className="about-green-number-text">
                  {card.description}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default GreenSession;
